import { lifecycleToLifecycle } from "~/assets/js/logic/lifecycleToLifecycle";

export default {
  SET_COMPUTERS(state, computers) {
    state.computers = computers;
  },

  SET_COMPUTER(state, updatedComputer) {
    const index = state.computers.collection.findIndex((c) => c.id === updatedComputer.id);
    if (index >= 0) {
      state.computers.collection.splice(index, 1, updatedComputer);
    }
  },

  DELETE_COMPUTER(state, id) {
    const index = state.computers.collection.findIndex((c) => c.id === id);
    if (index >= 0) {
      state.computers.collection.splice(index, 1);
    }
  },

  DELETE_ALL_COMPUTERS(state) {
    state.computers = null;
  },

  SET_AGENCY(state, agency) {
    state.agency = agency;
  },

  SET_TAGS(state, tags) {
    state.tags = tags.tags;
  },

  ADD_TAGS(state, tags) {
    state.tags = [...new Set([...state.tags, ...(tags || [])])];
  },

  MARK_FOR_REMOVAL(state, id) {
    const index = state.computers.collection.findIndex((c) => c.id === id);
    if (index >= 0) {
      state.computers.collection.splice(index, 1, {
        ...state.computers.collection[index],
        markedForRemoval: true,
      });
    }
  },

  REMOVE_SELECTED_COMPUTERS(state, selection) {
    state.computers.collection = state.computers.collection.filter(
      (c) => !selection.includes(c.id),
    );
  },

  UNINSTALL_SELECTED_COMPUTERS(state, selection) {
    state.computers.collection = state.computers.collection.map((computer) =>
      selection.includes(computer.id) ? { ...computer, markedForRemoval: true } : computer,
    );
  },

  SET_CURRENT_COMPUTER(state, currentComputer) {
    state.currentComputer = currentComputer;
  },

  RESET_CURRENT_COMPUTER(state) {
    state.currentComputer = null;
  },

  SET_VACCINATED_STATUS(state, agents) {
    const computers = state.computers.collection;
    for (const agent of agents) {
      const index = computers.findIndex((c) => c.id === agent.id);
      if (index >= 0) {
        computers.splice(index, 1, agent);
      }
    }
  },

  SET_DEPLOYMENT_STATUS(state, { agentId, vaccineIds }) {
    const collection = state.vaccineDeployments[agentId]?.collection;
    if (!collection) return;
    const index = collection.findIndex((d) => d.id === vaccineIds[0]);
    if (index >= 0) {
      const deployment = {
        ...collection[index],
        status: lifecycleToLifecycle(collection[index].status),
      };
      collection.splice(index, 1, deployment);
    }
  },

  SET_DEPLOYMENT_VACCINATED_STATUS(state, { agentIds, vaccineId }) {
    for (const agentId of agentIds) {
      const collection = state.vaccineDeployments[agentId]?.collection;
      if (!collection) continue;
      const index = collection.findIndex((d) => d.id === vaccineId);
      if (index >= 0) {
        const deployment = {
          ...collection[index],
          status: lifecycleToLifecycle(collection[index].status),
        };
        collection.splice(index, 1, deployment);
      }
    }
  },

  SET_VACCINE_DEPLOYMENTS(state, { parent, vaccineDeployments }) {
    this._vm.$set(state.vaccineDeployments, parent, vaccineDeployments);
  },

  REMOVE_VACCINE_DEPLOYMENTS(state, { parent }) {
    this._vm.$delete(state.vaccineDeployments, parent);
  },

  REMOVE_ALL_VACCINE_DEPLOYMENTS(state) {
    for (const key of Object.keys(state.vaccineDeployments)) {
      this._vm.$delete(state.vaccineDeployments, key);
    }
  },

  SET_LAST_VERSION(state, lastVersion) {
    state.lastVersion = lastVersion;
  },

  SET_LOADING(state, loading) {
    state.loading = loading;
  },

  SET_PAGE(state, page) {
    state.page = page;
  },

  SET_SORT_BY(state, sortBy) {
    state.sortBy = sortBy;
  },

  SET_ORDER_BY(state, orderBy) {
    state.orderBy = orderBy;
  },

  SET_SEARCH(state, search) {
    state.search = search;
  },
};
